

export * from './content/content.component';
export * from './nav-item/nav-item.component';
export * from './tabs.component';
export * from './tabs.module';